import React from 'react';
import StyledSelect from '../../components/StyledSelect';
import { TIER_OPTIONS, TIER_DESCRIPTION } from './trainAgentConstants';
import { blockStyle, labelStyle } from './trainAgentStyles';

export function TrainAgentTierBlock({ vm }) {
  const { bot, handleTierChange } = vm;

  return (
    <div style={{ ...blockStyle, display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '16px' }}>
      <div style={{ minWidth: '200px' }}>
        <label style={labelStyle}>Modelo do agente</label>
        <StyledSelect
          value={bot.tier || 'avancado'}
          onChange={handleTierChange}
          options={TIER_OPTIONS.map((o) => ({ value: o.value, label: o.label }))}
          placeholder="— Modelo —"
        />
      </div>
      <p style={{ color: '#B0BEC5', fontSize: '13px', margin: 0, marginTop: '28px' }}>
        {TIER_DESCRIPTION[bot.tier || 'avancado']}
      </p>
    </div>
  );
}
